<template>
  <PageSection>
    <WithSidebar placement="left" collapse="top">
      <template #sidebar>
        <ResponsiveUserPageSidebar :user="user" />
      </template>
      <template #default>
        <SectionBox>
          <BasicSection>
            <UserPagePlaceholder
              v-if="placeholder"
              :placeholder="placeholder"
            />
            <ContentSection
              v-else
              title="Рекомендательные письма"
              appearance="resume"
            >
              <template v-if="recommendationLetters.createHref" #aside>
                <BasicLink
                  :href="recommendationLetters.createHref"
                  appearance="blue-bold"
                  class="mq-not-mobile"
                >
                  Написать рекомендательное письмо
                </BasicLink>
                <BasicButton
                  :href="recommendationLetters.createHref"
                  class="mq-mobile-only"
                >
                  <SvgIcon icon="plus" color="muted" size="18" />
                </BasicButton>
              </template>
              <RecommendationLetters
                v-if="!recommendationLetters.placeholder"
                :letters="recommendationLetters.items"
                :approve-fallback-href="recommendationLetters.approveFallbackHref"
              />
              <NoContent
                v-else
                :title="recommendationLetters.placeholder.title"
                :description="recommendationLetters.placeholder.description"
                :icon="$options.noLettersImage"
              />
            </ContentSection>
          </BasicSection>
        </SectionBox>
      </template>
    </WithSidebar>
  </PageSection>
</template>

<script>
  import BasicButton from 'src/components/BasicButton/BasicButton.vue';
  import BasicLink from 'src/components/BasicLink/BasicLink.vue';
  import SvgIcon from 'src/components/icons/SvgIcon/SvgIcon.vue';
  import NoContent from 'src/components/placeholders/NoContent/NoContent.vue';
  import RecommendationLetters from 'src/components/resume/RecommendationLetters/RecommednationLetters.vue';
  import SectionBox from 'src/components/SectionBox/SectionBox.vue';
  import BasicSection from 'src/components/sections/BasicSection/BasicSection.vue';
  import ContentSection from 'src/components/sections/ContentSection/ContentSection.vue';
  import PageSection from 'src/components/sections/PageSection/PageSection.vue';
  import ResponsiveUserPageSidebar from 'src/components/users/ResponsiveUserPageSidebar/ResponsiveUserPageSidebar.vue';
  import UserPagePlaceholder from 'src/components/users/UserPagePlaceholder/UserPagePlaceholder.vue';
  import WithSidebar from 'src/components/WithSidebar/WithSidebar.vue';

  import noLettersImage from 'images/no_content.icon.recommendation.png'
  
  export default {
    name: 'UserRecommendationLettersPage',
    components: {
      ResponsiveUserPageSidebar,
      RecommendationLetters,
      SvgIcon,
      BasicButton,
      BasicLink,
      ContentSection,
      BasicSection,
      SectionBox,
      UserPagePlaceholder,
      NoContent,
      WithSidebar,
      PageSection,
    },
    props: {
      user: {
        type: Object,
        required: true,
      },
      recommendationLetters: Object,
      placeholder: Object,
    },
    noLettersImage: {
      src: noLettersImage,
      width: 90,
      height: 69
    },
  }
</script>